import { z } from "zod";

const MONEDAS = ["COP", "USD", "EUR"] as const;

const productoFinancieroSchema = z.object({
  tipo: z
    .string({
      required_error: "Campo obligatorio",
    })
    .min(1, "El tipo de producto es obligatorio"),
  numero: z
    .string({
      required_error: "Campo obligatorio",
    })
    .min(1, "El número es obligatorio"),
  entidad: z
    .string({
      required_error: "Campo obligatorio",
    })
    .min(1, "La entidad es obligatoria"),
  monto: z.union([z.string(), z.number()]).refine((val) => {
    const num = typeof val === "string" ? parseFloat(val) : val;
    return !isNaN(num) && num > 0;
  }, "El monto debe ser mayor a 0"),
  pais: z
    .string({
      required_error: "El pais es obligatorio",
    })
    .nonempty("El país es obligatorio"),
  moneda: z.enum(MONEDAS, {
    errorMap: () => ({ message: "Debe seleccionar una moneda" }),
  }),
});

export const InternationalInfoSchema = z
  .object({
    realizaOperaciones: z.enum(["si", "no"], {
      required_error: "Debe indicar si realiza operaciones internacionales",
    }),
    operaciones: z
      .object({
        importaciones: z.boolean().optional(),
        exportaciones: z.boolean().optional(),
        otras: z.boolean().optional(),
        otrasDetalle: z.string().optional(),
      })
      .optional(),
    // .refine((ops) => ops.importaciones || ops.exportaciones || ops.otras, {
    //   message: "Debe seleccionar al menos una operación",
    //   path: ["operaciones"],
    // })
    // .refine((ops) => !ops.otras || (ops.otras && !!ops.otrasDetalle), {
    //   message: "Debe especificar el detalle si marca 'Otras'",
    //   path: ["otrasDetalle"],
    // }),

    productos: z
      .object({
        inversiones: z.boolean().optional(),
        transferencias: z.boolean().optional(),
        otros: z.boolean().optional(),
        otrosDetalle: z.string().optional(),
      })
      .optional(),
    // .refine(
    //   (prods) => prods.inversiones || prods.transferencias || prods.otros,
    //   {
    //     message: "Debe seleccionar al menos un producto",
    //     path: ["productos"],
    //   }
    // )
    // .refine(
    //   (prods) => !prods.otros || (prods.otros && !!prods.otrosDetalle),
    //   {
    //     message: "Debe especificar el detalle si marca 'Otros'",
    //     path: ["otrosDetalle"],
    //   }
    // ),

    productosFinancieros: z.array(productoFinancieroSchema).optional(),
  })
  .superRefine((data, ctx) => {
    if (data.realizaOperaciones === "si") {
      // 🔹 Validar operaciones
      if (
        !data.operaciones?.importaciones &&
        !data.operaciones?.exportaciones &&
        !data.operaciones?.otras
      ) {
        ctx.addIssue({
          code: "custom",
          path: ["operaciones"],
          message: "Debe seleccionar al menos una operación",
        });
      }

      if (data.operaciones!.otras && !data.operaciones!.otrasDetalle) {
        ctx.addIssue({
          code: "custom",
          path: ["operaciones", "otrasDetalle"],
          message: "Debe especificar el detalle si marca 'Otras'",
        });
      }

      // 🔹 Validar productos
      if (
        (data.productos?.inversiones &&
          data.productosFinancieros?.length === 0) ||
        (data.productos?.transferencias &&
          data.productosFinancieros?.length === 0) ||
        (data.productos?.otros && data.productosFinancieros?.length === 0)
      ) {
        ctx.addIssue({
          code: "custom",
          path: ["productosFinancieros"],
          message: "Debe seleccionar al menos un producto",
        });
      }

      if (data.productos!.otros && !data.productos!.otrosDetalle) {
        ctx.addIssue({
          code: "custom",
          path: ["productos", "otrosDetalle"],
          message: "Debe especificar el detalle si marca 'Otros'",
        });
      }
    }
  });

export type OperacionesInternacionalesSchema = z.infer<
  typeof InternationalInfoSchema
>;
